"use client"
import Image from "next/image"

import { Text } from "@/elements"
import React, { FC } from "react"
import adidas from "@/public/marketing/trusted-by-carousel/dark-mode/Logo_Dark_Adidas.png"
import atlantic from "@/public/marketing/trusted-by-carousel/dark-mode/Logo_Dark_Atlantic.png"
import capital from "@/public/marketing/trusted-by-carousel/dark-mode/Logo_Dark_Capital.png"
import erewhon from "@/public/marketing/trusted-by-carousel/dark-mode/Logo_Dark_Erewhon.png"
import frankies from "@/public/marketing/trusted-by-carousel/dark-mode/Logo_Dark_Frankies.png"
import nike from "@/public/marketing/trusted-by-carousel/dark-mode/Logo_Dark_Nike.png"
import oncloud from "@/public/marketing/trusted-by-carousel/dark-mode/Logo_Dark_On.png"
import skims from "@/public/marketing/trusted-by-carousel/dark-mode/Logo_Dark_Skims.png"
import spotify from "@/public/marketing/trusted-by-carousel/dark-mode/Logo_Dark_Spotify.png"
import warner from "@/public/marketing/trusted-by-carousel/dark-mode/Logo_Dark_Warner.png"
import { Marquee } from "@/components/Marquee"

interface Props {}

const sharedProps = {
  className: "size-[45px] invert",
}

export const TrustedBy: FC<Props> = props => {
  return (
    <div className="h-[74px]">
      <Text className="text-fg-2" variant="caption">
        Trusted by:
      </Text>
      <div className="mt-3 w-full">
        <Marquee repeat={3} className="[--duration:30s] [--gap:0rem]">
          <Image key={1} {...sharedProps} src={spotify} alt="Spotify" />
          <Image key={2} {...sharedProps} src={erewhon} alt="Erewhon" />
          <Image key={3} {...sharedProps} src={nike} alt="Nike" />
          <Image key={4} {...sharedProps} src={skims} alt="Skims" />
          <Image key={5} {...sharedProps} src={oncloud} alt="Oncloud" />
          <Image key={6} {...sharedProps} src={capital} alt="Capital Records" />
          <Image key={7} {...sharedProps} src={warner} alt="Warner Records" />
          <Image key={8} {...sharedProps} src={frankies} alt="Frankies Bikinis" />
          <Image key={9} {...sharedProps} src={adidas} alt="Adidas" />
          <Image key={10} {...sharedProps} src={atlantic} alt="Atlantic" />
        </Marquee>
      </div>
    </div>
  )
}
